<template>
    <div>
        <label v-show="debugMode">
            Debug mode
            <input type="checkbox" name="" id="" v-model="debugMode" />
        </label>

        <Tabs class="mt-5">
            <Tab :title="$tc('messages.teachers', 2)" :selected="true">
                <div class="md:grid md:grid-cols-6 md:gap-6">
                    <div v-for="teacher in teachersWithSchedules" :key="teacher.id">
                        <div>
                            <div class="flex items-center">
                                <div>
                                    <img
                                        class="inline-block h-9 w-9 rounded-full"
                                        :src="teacher.avatar_or_default"
                                        alt=""
                                    />
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                                        {{ teacher.first_name }}
                                        <span v-show="teacher.hoursCount" class="text-gray-600"
                                            >({{ teacher.hoursCount }})</span
                                        >
                                    </p>
                                    <p class="text-xs font-medium text-gray-500 group-hover:text-gray-700">
                                        {{ teacher.last_name }}
                                    </p>
                                </div>
                            </div>
                            <div class="md:grid md:grid-cols-5 md:gap-1 w-full">
                                <div
                                    v-for="(day, dayIndex) in teacher.schedule.days"
                                    :key="day.id"
                                    :class="dayIndex % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
                                >
                                    <div>
                                        <div class="h-6 text-center">
                                            {{ day.initial }}
                                        </div>
                                        <div class="flex-col">
                                            <div
                                                v-for="(hour, hourIndex) in day.hours"
                                                :key="hour.id"
                                                class=""
                                                :class="hourIndex % 2 === 0 ? 'bg-gray-200' : ''"
                                            >
                                                <div class="text-sm">
                                                    <!--                        {{ hour.time }}-->
                                                </div>
                                                <div
                                                    v-if="hour.timeslots.length === 0"
                                                    class="w-full h-6 border-2 border-white bg-gray-100"
                                                ></div>
                                                <template v-else>
                                                    <template
                                                        v-for="(timeslot, timeslotsIndex) in hour.timeslots"
                                                        :key="timeslotsIndex"
                                                    >
                                                        <div
                                                            class="w-full h-6 border-2 border-white flex justify-center align-center"
                                                            :class="getColorClasses(timeslot.color)"
                                                            :title="getDisplayTitleForTeachers(timeslot)"
                                                        >
                                                            <!--                            {{  hour.timeslots.length }}-->
                                                            <span class="text-sm">{{
                                                                getGroupName(timeslot.group_id)
                                                            }}</span>
                                                        </div>
                                                    </template>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Tabs class="mt-5">
                    <Tab :title="`${teacher.full_name}`" v-for="teacher in teachers" :key="teacher.id">
                        <div class="md:grid md:grid-cols-5 md:gap-6 w-full">
                            <div
                                v-for="(day, dayIndex) in schedule.days"
                                :key="day.id"
                                :class="dayIndex % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
                            >
                                <div>
                                    <div>
                                        {{ day.name }}
                                    </div>
                                    <div class="flex-col">
                                        <div
                                            v-for="(hour, hourIndex) in day.hours"
                                            :key="hour.id"
                                            class="h-20"
                                            :class="hourIndex % 2 === 0 ? 'bg-gray-200' : ''"
                                        >
                                            <div class="text-sm">
                                                {{ hour.time }}
                                            </div>
                                            <template
                                                v-if="
                                                    hour.timeslots.filter((t) => t.teacher_id === teacher.id).length ===
                                                    0
                                                "
                                            >
                                                <div class="flex justify-center">
                                                    <button
                                                        @click="openTimeslotForm(teacher, day, hour)"
                                                        type="button"
                                                        class="inline-flex items-center border border-transparent rounded-full shadow-sm text-white bg-gray-300 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                            aria-hidden="true"
                                                            class="h-5 w-5"
                                                        >
                                                            <path
                                                                fill-rule="evenodd"
                                                                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                                                                clip-rule="evenodd"
                                                            ></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <template
                                                    v-for="(timeslot, timeslotsIndex) in hour.timeslots"
                                                    :key="timeslotsIndex"
                                                >
                                                    <div v-if="teacher.id === timeslot.teacher_id">
                                                        <div
                                                            :class="getColorClasses(timeslot.color)"
                                                            class="w-full h-full"
                                                        >
                                                            <div class="flex justify-end">
                                                                <button
                                                                    type="button"
                                                                    @click="
                                                                        removeTimeSlot(hour.timeslots, timeslotsIndex)
                                                                    "
                                                                    class="shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white"
                                                                >
                                                                    <span class="sr-only">Remove small option</span>
                                                                    <svg
                                                                        class="h-2 w-2"
                                                                        stroke="currentColor"
                                                                        fill="none"
                                                                        viewBox="0 0 8 8"
                                                                    >
                                                                        <path
                                                                            stroke-linecap="round"
                                                                            stroke-width="1.5"
                                                                            d="M1 1l6 6m0-6L1 7"
                                                                        />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                            {{ getDisplayTitleForTeachers(timeslot) }}
                                                        </div>
                                                        <BadgePill class="h-full hidden">
                                                            <span v-if="debugMode" class="text-xs">
                                                                ({{ timeslot.teacher_id }})
                                                            </span>
                                                            <button
                                                                type="button"
                                                                @click="removeTimeSlot(hour.timeslots, timeslotsIndex)"
                                                                class="shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white"
                                                            >
                                                                <span class="sr-only">Remove small option</span>
                                                                <svg
                                                                    class="h-2 w-2"
                                                                    stroke="currentColor"
                                                                    fill="none"
                                                                    viewBox="0 0 8 8"
                                                                >
                                                                    <path
                                                                        stroke-linecap="round"
                                                                        stroke-width="1.5"
                                                                        d="M1 1l6 6m0-6L1 7"
                                                                    />
                                                                </svg>
                                                            </button>
                                                        </BadgePill>
                                                        <div v-if="debugMode && false" class="text-xs">
                                                            {{ timeslot }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                </Tabs>

                <SlideOver :show="show" @close="closeTimeslotForm()">
                    <form action="" @submit.prevent="addTimeSlot()" class="bg-indigo-50 p-5">
                        <div v-if="selected_teacher">
                            {{ selected_teacher.full_name }}
                        </div>
                        <div v-if="selected_day && selected_hour">
                            {{ selected_day.name }} - {{ selected_hour.time }}
                        </div>

                        <div class="md:grid md:grid-cols-6 md:gap-6">
                            <div class="sm:col-span-6">
                                <div class="mt-1">
                                    <FormLabel :value="$t('messages.group')" for="group_id" />
                                    <FormSelect v-model.number="form.group_id" :options="groupsSelect" class="w-full" />
                                </div>
                            </div>

                            <div class="sm:col-span-6">
                                <div class="mt-1">
                                    <FormLabel :value="$tc('messages.subject', 1)" for="subject_id" />
                                    <FormSelect
                                        v-model.number="form.subject_id"
                                        :options="subjectsSelect"
                                        class="w-full"
                                    />
                                </div>
                            </div>

                            <div class="sm:col-span-6">
                                <div class="mt-1">
                                    <FormLabel :value="$t('messages.other')" for="other" />
                                    <FormInput v-model="form.other" class="w-full"></FormInput>
                                </div>
                            </div>

                            <div class="sm:col-span-6">
                                <div class="m-1 p-1 bg-white">
                                    <FormLabel :value="$tc('messages.colours', 1)" for="other" />
                                    <template v-for="color in colors" :key="color">
                                        <label
                                            for=""
                                            class="inline-block h-8 w-8 border-solid"
                                            :class="[
                                                getColorClasses(color),
                                                form.color === color ? 'border-indigo-500' : '',
                                            ]"
                                        >
                                            <input
                                                type="radio"
                                                name="color"
                                                :value="color"
                                                v-model="form.color"
                                                class=""
                                            />
                                        </label>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <!--            <FormSelect v-model.number="form.group_id" :required="form.subject_id !== ''" :options="groupsSelect"></FormSelect>-->
                        <!--            <FormSelect v-model.number="form.subject_id" :required="form.group_id !== ''" :options="subjectsSelect"></FormSelect>-->
                        <!--            <FormInput v-model="form.other" :disabled="form.group_id !== '' || form.subject_id !== ''" placeholder="only available when there is no group selected" class="w-full"></FormInput>-->
                        <!--            <div class="m-1 p-1 bg-white">-->
                        <!--              <template v-for="color in colors">-->
                        <!--                <label for="" class="inline-block h-6 w-6 border-solid " :class="[getColorClasses(color), form.color === color ? 'border-indigo-500' : '']"  :key="color" >-->
                        <!--                  <input type="radio" name="color" :value="color" v-model="form.color" class="">-->
                        <!--                </label>-->
                        <!--              </template>-->
                        <!--            </div>-->

                        <SubmitFormButton :button-text="$t('messages.add')" :processing="form.processing" />
                    </form>
                </SlideOver>
            </Tab>

            <Tab :title="$tc('messages.groups', 2)" :selected="false">
                <Tabs class="mt-5">
                    <Tab :title="group.name" v-for="group in groupsWithSchedules" :key="group.id">
                        <div class="md:grid md:grid-cols-5 md:gap-6 w-full">
                            <div
                                v-for="(day, dayIndex) in group.schedule.days"
                                :key="day.id"
                                :class="dayIndex % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
                            >
                                <div>
                                    <div>
                                        {{ day.name }}
                                    </div>
                                    <div class="flex-col">
                                        <div
                                            v-for="(hour, hourIndex) in day.hours"
                                            :key="hour.id"
                                            class="h-20"
                                            :class="hourIndex % 2 === 0 ? 'bg-gray-200' : ''"
                                        >
                                            <div class="text-sm">
                                                {{ hour.time }}
                                            </div>
                                            <template
                                                v-for="(timeslot, timeslotsIndex) in hour.timeslots"
                                                :key="timeslotsIndex"
                                            >
                                                <BadgePill
                                                    :color="timeslot.color"
                                                    :title="getDisplayTitleForGroups(timeslot)"
                                                >
                                                    {{ getStringFromParts(timeslot, ['subject', 'other']) }}
                                                </BadgePill>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </Tab>
        </Tabs>

        <div class="hidden">
            <button type="button" @click="log()">log</button>
        </div>
    </div>
</template>

<script>
import Tab from '@/components/Tab.vue';
import Tabs from '@/components/Tabs.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import ButtonPrimary from '@/components/ButtonPrimary.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import BadgePill from '@/components/BadgePill.vue';
import SlideOver from '@/components/SlideOver.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    emits: ['update:modelValue'],
    name: 'ScheduleMaker',

    components: {
        SubmitFormButton,
        Tab,
        Tabs,
        FormSelect,
        FormLabel,
        ButtonPrimary,
        FormInput,
        BadgePill,
        SlideOver,
    },

    props: {
        teachers: {
            required: true,
            type: Array,
        },
        groups: {
            required: true,
            type: Array,
        },
        subjects: {
            required: true,
            type: Array,
        },
        modelValue: {
            required: true,
            type: Object,
        },
    },

    watch: {
        schedule: {
            handler(newVal) {
                this.$emit('update:modelValue', newVal);
            },
            deep: true,
        },
    },

    computed: {
        teachersWithSchedules: function () {
            return this.teachers.map((t) => {
                let hoursCount = 0;
                let string = JSON.stringify(this.schedule);
                let parsed = JSON.parse(string);
                // schedule => days => hours => timeslots
                parsed.days = parsed.days.map((d) => {
                    d.hours = d.hours.map((h) => {
                        const teacherTimeslots = h.timeslots.filter((timeslot) => timeslot.teacher_id === t.id);
                        h.timeslots = teacherTimeslots;
                        hoursCount += teacherTimeslots.length;
                        return h;
                    });
                    return d;
                });
                t.schedule = parsed;
                t.hoursCount = hoursCount;
                return t;
            });
        },
        groupsWithSchedules: function () {
            return this.groups.map((g) => {
                let string = JSON.stringify(this.schedule);
                let parsed = JSON.parse(string);
                // schedule => days => hours => timeslots
                parsed.days = parsed.days.map((d) => {
                    d.hours = d.hours.map((h) => {
                        h.timeslots = h.timeslots.filter((timeslot) => timeslot.group_id === g.id);
                        return h;
                    });
                    return d;
                });
                g.schedule = parsed;
                return g;
            });
        },
        groupsSelect: function () {
            return this.groups.map((g) => ({
                value: g.id,
                text: g.name,
            }));
        },
        subjectsSelect: function () {
            return this.subjects.map((g) => ({
                value: g.id,
                text: g.name,
            }));
        },
    },

    methods: {
        log() {
            const parsed = JSON.parse(JSON.stringify(this.schedule));
        },
        openTimeslotForm(teacher, day, hour) {
            this.selected_day = day;
            this.selected_hour = hour;
            this.selected_teacher = teacher;
            this.show = true;
        },
        closeTimeslotForm() {
            this.selected_day = null;
            this.selected_hour = null;
            this.selected_teacher = null;
            this.show = false;
            this.form.group_id = '';
            this.form.subject_id = '';
            this.form.other = '';
        },
        getTeacherName(id) {
            return this.teachers.find((g) => g.id === id)?.name;
        },
        getSubjectName(id) {
            return this.subjects.find((g) => g.id === id)?.name;
        },
        getGroupName(id) {
            return this.groups.find((g) => g.id === id)?.name;
        },
        getDisplayTitleForTeachers(timeslot) {
            return this.getStringFromParts(timeslot, ['group', 'subject', 'other']);
        },
        getDisplayTitleForGroups(timeslot) {
            return this.getStringFromParts(timeslot, ['teacher', 'subject', 'other']);
        },
        getStringFromParts(timeslot, only) {
            const parts = [];

            if (only.includes('teacher')) {
                parts.push(this.teachers.find((t) => t.id === timeslot.teacher_id)?.full_name);
            }
            if (only.includes('group')) {
                parts.push(this.groups.find((g) => g.id === timeslot.group_id)?.name);
            }
            if (only.includes('subject')) {
                parts.push(this.subjects.find((g) => g.id === timeslot.subject_id)?.name);
            }
            if (only.includes('other')) {
                parts.push(timeslot.other);
            }
            return parts.filter((p) => p).join(' - ');
        },
        getColorClasses(color) {
            if (color === 'gray') {
                return 'bg-gray-100 text-gray-800';
            }
            if (color === 'red') {
                return 'bg-red-100 text-red-800';
            }
            if (color === 'yellow') {
                return 'bg-yellow-100 text-yellow-800';
            }
            if (color === 'green') {
                return 'bg-green-100 text-green-800';
            }
            if (color === 'blue') {
                return 'bg-blue-100 text-blue-800';
            }
            if (color === 'indigo') {
                return 'bg-indigo-100 text-indigo-800';
            }
            if (color === 'purple') {
                return 'bg-purple-100 text-purple-800';
            }
            if (color === 'pink') {
                return 'bg-pink-100 text-pink-800';
            }

            return 'bg-indigo-100 text-indigo-800';
        },
        removeTimeSlot(timeslots, timeslotsIndex) {
            timeslots.splice(timeslotsIndex, 1);
        },
        addTimeSlot() {
            const timeslot = {
                other: this.form.other,
                teacher_id: this.selected_teacher.id, //get from tab
                group_id: this.form.group_id,
                subject_id: this.form.subject_id,
                color: this.form.color,
            };
            this.selected_hour.timeslots.push(timeslot);

            this.closeTimeslotForm();
        },
    },

    data() {
        return {
            debugMode: false,
            show: false,
            selected_teacher: null,
            selected_day: null,
            selected_hour: null,
            colors: ['gray', 'red', 'yellow', 'green', 'blue', 'indigo', 'purple', 'pink'],
            form: {
                group_id: '',
                subject_id: '',
                other: '',
                color: 'indigo',
            },
            schedule: this.modelValue,
        };
    },
};
</script>
